<div class="container-chart" [ngClass]="[size, styleTheme]">
  <ul class="info">
    <li *ngFor="let data of data">
      <div class="circle" [style.background]="data.backgroundStyle.color">
      </div>
      {{ data.title }} valor: {{data.value}}
    </li>
  </ul>

  <div class="content">
    <div class="velas">
      <div class="linhas">
<!--        <div class="linha">-->
<!--          <div class="value">0</div>-->
<!--          <div class="divider"></div>-->
<!--        </div>-->
        <div class="linha" *ngFor="let valor of generateScaledArray(menorValor,maiorValor)">
          <div class="value">{{ valor }}</div>
          <div class="divider"></div>
        </div>
      </div>
      <div class="vela" [appTooltip]="data.title+ ': ' +data.value" *ngFor="let data of data"
           [ngClass]="retornaHeightAnimado(calcularPorcentagem(data.value))"
           [style.background]="data.backgroundStyle.color"
      ></div>
    </div>
    <div class="info-velas"></div>
  </div>
</div>
